<template>
  <div>
    <el-form :model="syncAddForm"
             label-width="100px"
             style="width: 520px;">
      <el-form-item label="名称">
        <el-input v-model="syncAddForm.name"
                  placeholder="同步器名称"></el-input>
      </el-form-item>
      <el-form-item label="源地址">
        <el-input v-model="syncAddForm.sourcePath"
                  placeholder="源地址路径，请使用unix风格绝对路径"></el-input>
      </el-form-item>
      <el-form-item label="目标地址">
        <el-input v-model="syncAddForm.rsyncUrl"
                  placeholder="rsync同步目标路径，如：rsync://sync@localhost/sync-data"></el-input>
      </el-form-item>
      <el-form-item label="同步密码">
        <el-input v-model="syncAddForm.rsyncPassword"
                  type="password"
                  placeholder="rsync模块密码"></el-input>
      </el-form-item>
      <el-form-item label="立即同步模式">
        <el-switch v-model="syncAddForm.isImmediately"></el-switch>
      </el-form-item>
      <el-form-item label="监听模式">
        <el-switch v-model="syncAddForm.isWatching"></el-switch>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="onConfirm"
                   :loading="commiting">添加</el-button>
        <el-button @click="$router.go(-1)"
                   :loading="commiting">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from '../api/api'
  ;

export default {
  name: 'sync-add',
  data() {
    return {
      syncAddForm: {},
      commiting: false,
    };
  },
  methods: {
    onConfirm() {
      this.$http.post(`${api.url}syncCreate`, this.syncAddForm).then(() => {
        this.$message({
          type: 'success',
          message: '添加成功',
        });
        this.$router.go(-1);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SyncAdd.vue